// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import mainSlider from './js/widgets/mainSlider.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import cardWidget7 from './js/widgets/cardsWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import customSignupWidget from './js/widgets/signupWidget.js';
import slideCards from './js/widgets/slideCards.js';
import sponsorsDoubleScroller from './js/widgets/sponsorsDoubleScroller.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
  if (globalThis.location.pathname === '/') {
    mainSlider();
    eventsWidget();
    cardWidget7();
    seoWidget();
    customSignupWidget();
    slideCards();
    sponsorsDoubleScroller('scroller-sponsors-first', scrollerSponsorsFirstOpts, 6);
    sponsorsDoubleScroller('scroller-sponsors-second', scrollerSponsorsSecondOpts, 6);
  }
});
